export default "https://assets.egbcdn.net/assets/packs/_/images/app/apk/apk-1-0a21d7feab2a7a45aaadfea1656d636e.png";